function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "e-apm\\u0101c\\u012Bba",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "01.-E---apm\\u0101c\\u012Bba---S\\u0101kums-(-pirm\\u0101-nodarb\\u012Bba)",
  transform: "translate(-1009.000000, -580.000000)",
  fill: "#059DC1",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Content",
  transform: "translate(294.000000, 80.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Intro",
  transform: "translate(0.000000, 209.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Text",
  transform: "translate(617.000000, 53.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(0.000000, 238.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon",
  transform: "translate(98.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.001,0 C4.486,0.001 0,4.487 0,10.001 C0,15.514 4.486,20 10,20.001 C15.515,20.001 20.001,15.515 20.001,10.001 C20,4.487 15.514,0.001 10.001,0 Z M10.001,2 C14.411,2.001 18,5.59 18.001,10.001 C18.001,14.412 14.412,18.001 10,18.001 C5.589,18 2,14.411 2,10.001 C2,5.59 5.589,2.001 10.001,2 Z M9.988,5.996 L9.988,9.001 L5.994,9.001 L5.994,11.001 L9.988,11.001 L9.988,14.005 L13.993,10.001 L9.988,5.996 Z",
  id: "icon"
}))))))));

function SvgIcRightArrowCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "559771FD-5842-4993-BBC9-B15C92BC8ACB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRightArrowCircle);
export default __webpack_public_path__ + "static/media/ic-right-arrow-circle.802c1300.svg";
export { ForwardRef as ReactComponent };